import ReactGA from 'react-ga';

const trackingId = process.env.REACT_APP_GA_TRACKING_CODE;

ReactGA.initialize(trackingId ?? '');
